import { useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { SUPPORTED_LANGUAGES, type SupportedLanguages } from '@/i18n'
import Flag from '@components/Flag.tsx'
import Button from '@components/designSystem/Button'
import { RadioButton, RadioButtonBase, RadioGroup } from '@components/designSystem/Radio'
import { useCurrentStoreId } from '@hooks/useCurrentStore.ts'
import { usePageHeader } from '@hooks/useHeader.ts'
import { useScanId } from '@hooks/useScan.ts'
import useTypedTranslation from '@hooks/useTypedTranslation.ts'
import { routesFactory } from '@utils/routes.ts'

function ChangeLanguageRoute() {
  const { t, i18n } = useTypedTranslation()
  usePageHeader({ title: t('account.language.title') })

  const navigate = useNavigate()
  const currentStoreId = useCurrentStoreId()
  const currentScanId = useScanId()

  const [selectedLanguage, setSelectedLanguage] = useState<SupportedLanguages>(i18n.resolvedLanguage as SupportedLanguages)

  async function handleSaveClick() {
    await i18n.changeLanguage(selectedLanguage)
    navigate(routesFactory.account(currentStoreId, currentScanId))
  }

  return (
    <div className='relative size-full'>
      <RadioGroup
        aria-label={t('account.language.label')}
        className='flex size-full flex-col items-center p-2'
        value={selectedLanguage}
        onChange={setSelectedLanguage}
      >
        {
          SUPPORTED_LANGUAGES.slice().sort().map(lang => (
            <RadioButton
              key={lang}
              value={lang}
              aria-label={t(`account.language.options.${lang}`)}
              className={`
                group flex w-full cursor-pointer flex-col gap-3 rounded-lg bg-white p-5 shadow-xs-skeumorphic
                transition-all
                hover:border-border-brand
              `}
            >
              {(radioProps) => (
                <div className='flex w-full items-center justify-between'>
                  <div className='flex gap-3'>
                    <Flag lang={lang} />
                    <p className='font-medium'>{t(`account.language.options.${lang}`)}</p>
                  </div>
                  <RadioButtonBase className='col-start-3 row-span-full items-center' size='md' {...radioProps} />
                </div>
              )}
            </RadioButton>
          )
          )
        }
      </RadioGroup>
      <Button
        className='absolute bottom-12 w-full'
        onClick={handleSaveClick}
        isDisabled={!selectedLanguage}
      >
        {t('common.save')}
      </Button>
    </div>

  )
}

export default ChangeLanguageRoute